<template>
  <footer
    class="footer"
    :class="{
      showing: !isShow,
      notMobile: windowWidth >= 600 && this.windowHeight >= 600,
    }"
  >
    <div class="row">
      <div class="col-12">
        <div class="container">
          <nav class="menu">
            <a
              v-if="!HideHomeTab"
              href="/home"
              crm_at="menu_home"
              class="menu-item"
              @click="analyticTracking('menu_home')"
            >
              <a-icon
                type="home"
                class="a-icons"
                :class="{ active: $route.name == 'home' }"
                theme="filled"
              />
              <span
                class="menu-item-label"
                :class="{ active: $route.name == 'home' }"
                >{{ lbl.main.home }}</span
              >
            </a>

            <!-- EarnPoint -->

            <a
              v-if="
                (storeinfo.ShowCheckInMission7Days && missionData) ||
                storeinfo.ShowCampaignEnterCodeBanner ||
                (storeinfo.ShowCampaignFriendGetFriendBanner && fgfData) ||
                storeinfo.ShowCampaignSurveyBanner
              "
              href="/missionhub"
              crm_at="menu_missionhub"
              class="menu-item"
            >
              <a-icon
                type="plus-circle"
                class="a-icons"
                :class="{ active: $route.name == 'missionhub' }"
                theme="filled"
              />
              <span
                class="menu-item-label"
                :class="{ active: $route.name == 'missionhub' }"
                >{{ lbl.mission.mission }}</span
              >
            </a>

            <!-- Bee's rewards -->
            <a
              v-if="storeinfo.ShowBeeRewards"
              crm_at="menu_bee_rewards"
              class="menu-item"
              @click="handleClickBeeReward()"
            >
              <img
                v-if="beeRewardActive == true"
                src="../../assets/images/icon_bee_reward_active.svg"
                alt="bee reward active icon"
                class="custom-icon"
              />
              <img
                v-else
                src="../../assets/images/icon_bee_reward.svg"
                alt="bee reward icon"
                class="custom-icon"
              />
              <span
                class="menu-item-label"
                :class="{ active: beeRewardActive == true }"
                >{{ lbl.bee_reward }}</span
              >
            </a>

            <a
              v-if="!HideHistoryTab"
              href="/myrewards"
              crm_at="menu_myrewards"
              class="menu-item"
              @click="analyticTracking('menu_menu_myrewards')"
            >
              <a-icon
                type="star"
                class="a-icons"
                :class="{ active: $route.name == 'myrewards' }"
                theme="filled"
              />
              <span
                class="menu-item-label"
                :class="{ active: $route.name == 'myrewards' }"
                >{{ lbl.main.my_rewards }}</span
              >
            </a>
            <a
              v-if="!HideProfileTab"
              href="/profile"
              crm_at="menu_profile"
              class="menu-item"
              @click="analyticTracking('menu_profile')"
            >
              <div v-if="isUncompleteInfo" class="uncomplete"></div>
              <img
                v-if="profile_url"
                class="profile__image"
                :src="profile_url"
                alt="Avatar"
              />
              <a-avatar
                v-if="!profile_url"
                slot="avatar"
                class="a-icons"
                :class="{ active: $route.name == 'profile' }"
                :size="30"
                icon="user"
              />
              <span
                class="menu-item-label"
                :class="{ active: $route.name == 'profile' }"
                >{{ lbl.main.me }}
              </span>
            </a>
          </nav>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import CommonMixin from '@/mixin/CommonMixin'
import Account from '@/helper/AccountHelper.js'
import BzbsDashboard from '@/core/Home/BzbsDashboard'
import BzbsBeeRewards from '@/core/Account/service/BzbsBeeRewards.js'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'
import Vue from 'vue'

export default {
  name: 'FooterMenu',
  components: {},
  mixins: [CommonMixin, ResponsiveMixin],
  props: {
    isShow: Boolean,
  },
  data() {
    return {
      profile_url: '',
      HideHistoryTab: false,
      HideHomeTab: false,
      HideProfileTab: false,
      HideEarnPoint: false,
      MarketingMessage: {},
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      fgfData: null,
      missionData: false,
      beeRewardActive: false,
      storeinfo: {
        ShowCheckInMission7Days: false,
        ShowCampaignSurveyBanner: false,
        ShowCampaignEnterCodeBanner: false,
        ShowCampaignFriendGetFriendBanner: false,
        ShowBeeRewards: false,
        LinkSurvey: null,
      },
      isUncompleteInfo: false,
      LoginType: null,
      loginTypeList: [],
    }
  },
  created() {
    this.init()
    this.getActiveFGF()
    this.getloginmission()
  },
  methods: {
    analyticTracking(track) {
      Account.bzbsAnalyticTracking(
        'home_page',
        'home_page_' + track,
        'click_' + track,
        'on click',
      )
    },
    init() {
      Promise.all([
        this.getCustomerStore().then(res => {
          console.log('getCustomerStore : ', res)
          if (res) {
            if (res.StoreDetail) {
              this.HideHomeTab = res.StoreDetail.HideHomeTab
              this.HideHistoryTab = res.StoreDetail.HideHistoryTab
              this.HideProfileTab = res.StoreDetail.HideProfileTab
              this.MarketingMessage = res.MarketingMessage
              this.LoginType = res.StoreDetail.LoginType
              this.arrList(this.LoginType)
              this.storeinfo.ShowCheckInMission7Days =
                res.StoreDetail.ShowCheckInMission7Days
              this.storeinfo.ShowBeeRewards = res.StoreDetail.AllowBeeRewards
              this.storeinfo.ShowCampaignSurveyBanner =
                res.StoreDetail.ShowCampaignSurveyBanner
              this.storeinfo.ShowCampaignEnterCodeBanner =
                res.StoreDetail.ShowCampaignEnterCodeBanner
              this.storeinfo.ShowCampaignFriendGetFriendBanner =
                res.StoreDetail.ShowCampaignFriendGetFriendBanner
              this.storeinfo.LinkSurvey = res.StoreDetail.LinkSurvey
              if (res.StoreDetail.IsEarnPointfromCode != undefined) {
                this.HideEarnPoint = res.StoreDetail.IsEarnPointfromCode
              } else {
                this.HideEarnPoint = false
              }
            }
          }
        }),
      ]).then(() => {
        Account.apiGetProfile().then(data => {
          this.checkUncompleteUserInfo(data).then(isUncomplete => {
            console.log(isUncomplete)
            console.log(this.isUncompleteInfo)
          })
        })

        if (
          Account.getCacheCustom(
            'profileLine_' + Account.getCacheCustom('app_id'),
          )
        ) {
          if (
            Account.getCacheCustom(
              'profileLine_' + Account.getCacheCustom('app_id'),
            ).pictureUrl
          ) {
            this.profile_url = JSON.stringify(
              Account.getCacheCustom(
                'profileLine_' + Account.getCacheCustom('app_id'),
              ).pictureUrl,
            ).replace(/"/g, '')
          } else {
            this.profile_url = null
          }
        } else if (Account.getCacheFacebookUser()) {
          let picture = Account.getCacheFacebookUser().picture
          if (picture) {
            this.profile_url = JSON.stringify(picture.data.url).replace(
              /"/g,
              '',
            )
          }
        }
      })
    },
    arrList(string) {
      var list = string.split(',')
      this.loginTypeList = list
      return list
    },
    checkUncompleteUserInfo(user) {
      return new Promise(resolve => {
        if (user) {
          var params = {}
          Account.actionGetConsent(params, Account.getCacheToken()).then(
            result => {
              if (result.data.MarketingOption < this.MarketingMessage.Version) {
                this.isUncompleteInfo = true
                resolve(true)
              } else {
                if (
                  !user.strFirstName ||
                  !user.strLastName ||
                  !user.strBirthDate ||
                  !user.strContactNumber ||
                  !user.strGender ||
                  !user.strEmail
                ) {
                  if (!this.loginTypeList.includes('Line')) {
                    this.isUncompleteInfo = true
                    resolve(true)
                  } else {
                    this.isUncompleteInfo = false
                    resolve(false)
                  }
                } else {
                  this.isUncompleteInfo = false
                  resolve(false)
                }
              }
            },
          )
        } else {
          resolve(true)
        }
      })
    },
    getCustomerStore() {
      this.handleLoading(true)
      return new Promise(resolve => {
        BzbsDashboard.getCustomerStore()
          .then(res => {
            this.handleLoading(false)
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            console.log('getCustomerStore error', error)
            resolve(error)
          })
      })
    },
    getActiveFGF() {
      this.fgfData = null
      if (Account.getCacheToken()) {
        BzbsDashboard.getFGFGenLink()
          .then(res => {
            if (res.data.CrmPlusFriendGetFriend) {
              this.fgfData = true
              var toDay = Date.now()
              if (
                res.data.CrmPlusFriendGetFriend.ExpireDate * 1000 >= toDay &&
                res.data.CrmPlusFriendGetFriend.StatusId == 3
              ) {
                this.fgfData = true
              } else {
                this.fgfData = false
              }
            } else {
              this.fgfData = false
            }
          })
          .catch(err => {
            this.fgfData = false
            console.log(err)
          })
      }
    },
    getloginmission() {
      if (Account.getCacheToken()) {
        this.handleLoading(true)
        return new Promise(resolve => {
          BzbsDashboard.getloginmission()
            .then(res => {
              this.handleLoading(false)
              if (res) {
                if (res.data.length > 0) {
                  this.missionData = true
                } else {
                  this.missionData = false
                  resolve(res)
                }
              } else {
                this.missionData = false
                resolve(true)
              }
            })
            .catch(error => {
              this.missionData = false
              this.handleLoading(false)
              resolve(error)
            })
        })
      }
    },
    handleClickBeeReward() {
      this.handleLoading(true)
      this.beeRewardActive = true
      Account.bzbsAnalyticTracking(
        'home_page',
        'home_page_menu_bee_rewards',
        'click_menu_bee_rewards',
        'on click',
      )
      return new Promise(resolve => {
        BzbsBeeRewards.apiBeeRewardSetting()
          .then(res => {
            console.log('apiBeeRewardSetting success res ::', res.data.data.key)
            this.handleLoading(false)
            if (res.data && res.data.data.key) {
              this.gotoBeeReward(res.data && res.data.data.key)
            }
            resolve(true)
          })
          .catch(error => {
            console.log('apiBeeRewardSetting error ::', error)
            this.handleLoading(false)
            resolve(error)
          })
      })
    },
    gotoBeeReward(key) {
      let directUrl =
        Vue.bzbsConfig.bzbsBeeRewardDirectUrl + '/authbzbs?access_key=' + key
      this.beeRewardActive = false

      window.open(encodeURI(directUrl), '_self')
    },
  },
}
</script>

<style lang="scss">
@import '@/style/_mixin.scss';
.footer {
  padding-bottom: 110px;
  &.notMobile {
    padding-bottom: 0px;
  }
  &.showing {
    display: none;
  }
  .container {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 50px;
    z-index: 1;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    &.not-locale {
      bottom: 10px;
    }
  }

  .menu {
    display: flex;
    -webkit-box-flex: 1;
    flex-grow: 1;
    max-width: 370px;
    overflow: hidden;
    bottom: 10;
    width: 355px;
    height: 60px;
    margin: 0;
    padding: 10px 20px;
    border-radius: 100px;
    box-shadow: 0 0 10px 0 rgb(0 0 0 / 10%);
    background-color: #fff;
  }

  .menu-item {
    position: relative;
    place-items: center;
    gap: 4px 0px;

    .profile__image {
      width: 24px;
      height: 24px;
      border-radius: 50%;
    }

    .uncomplete {
      position: absolute;
      width: 8px;
      height: 8px;
      border-radius: 20px;
      background-color: #ff0000;
      top: -1px;
      right: 32%;
      z-index: 1;
    }

    display: grid;
    text-align: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    flex-basis: 0;
    line-height: 1.5;
    text-decoration: none;
    &:focus,
    &:hover {
      outline: none;
      .a-icons {
        color: #666666;
      }

      .menu-item-label {
        color: #666666;
      }
    }
  }

  .a-icons {
    display: block;
    font-size: 24px;
    color: #9b9b9b;
    transition: 0.25s ease;
  }
  .custom-icon {
    width: 24px;
    height: 24px;
  }

  .menu-item-label {
    display: block;
    font-size: 10px;
    color: #9b9b9b;
    transition: 0.25s ease;
    font-weight: 600;
  }

  .a-icons.active {
    color: #f9a601;
  }

  .menu-item-label.active {
    color: #f9a601;
  }
}
</style>
